export default {
  title: {
    id: 'bo_sellers-orders-drawers-import_csv_file-imeis_info_title',
    defaultMessage: 'Upload your IMEIs for smartphones only.',
  },
  infoBlockTitle: {
    id: 'bo_sellers-orders-drawers-import_csv_file-info_block_title',
    defaultMessage: 'Upload a CSV file formatted in {count} separate columns:',
  },
  infoBlockSubtitle: {
    id: 'bo_sellers-orders-drawers-import_csv_file-info_block_sub_title',
    defaultMessage:
      'Only orders with the status “To-be-shipped” will be updated.',
  },
  infoBlockLine1: {
    id: 'bo_sellers-orders-drawers-import_csv_file-order_line_item_id',
    defaultMessage: 'order_line_item_id (mandatory)',
  },
  infoBlockLine2: {
    id: 'bo_sellers-orders-drawers-import_csv_file-imei',
    defaultMessage: 'imei (mandatory)',
  },
} as const
